export const JIRA_ACCESS_ERROR = "authorize";
export const TIME_TRACKING_ERROR = "disableTimeSend";